module.exports = __webpack_public_path__ + "static/media/VajiraIcon.968986e1.png";